import { useSelfHiringContext } from "@/app/contexts/SelfHiringContext";
import { Button } from "@/view/components/ui/button";
import { CheckCircle } from "lucide-react";
import { useFormContext } from "react-hook-form";
import { toast } from "@/view/components/ui/use-toast";
import { useQuery } from "@tanstack/react-query";
import { TickCircle } from "iconsax-react";
import { PanLinkResponse } from "@/app/services/panService/getLink";
import { selfHireService } from "@/app/services/selfHireService";
import { PartnerType } from "@/app/utils/partners.enum";

export const Formalization = () => {
  const { cleanFormData, panData } = useSelfHiringContext();
  const methods = useFormContext();

  const { data, isLoading, isError } = useQuery<PanLinkResponse>({
    queryKey: ["panSelfHiringLink", panData?.state.preTransactionId],
    queryFn: () =>
      selfHireService.getLinkFormalize(panData?.state.preTransactionId!, PartnerType.PAN),
    enabled: !!panData?.state.preTransactionId,
  });

  const handleBackToInitial = () => {
    methods.reset({});
    cleanFormData();
  };

  const copyLink = () => {
    navigator.clipboard.writeText(data?.linkCliente ?? '');
    if (data?.linkCliente) {
      toast({
        title: "Link da proposta copiado",
      });
    }
  };

  return (
    <div className="flex w-full flex-col items-center justify-center gap-6 rounded-xl border border-gray02 bg-white01 p-4 py-10 text-center dark:border-gray-700 dark:bg-gray-900">
      <CheckCircle className="h-14 w-14 text-green-600" />

      <div className="flex flex-col gap-1">
        <h1 className="text-xl font-bold dark:text-white">
          Contrato finalizado com sucesso
        </h1>
        <p className="text-sm font-medium text-black04 dark:text-gray-400">
          Parabéns! Sua proposta foi finalizada com sucesso. O link de
          formalização será enviado via WhatsApp e SMS em alguns minutos, fique
          atento!.
        </p>
      </div>

      {data?.linkCliente && (
        <>
          <div className="mt-10 flex flex-col items-start gap-1.5 px-6">
            <TickCircle variant="Bold" size={40} className="text-success" />
            <strong className="font-semibold dark:text-white">
              Contrato finalizado com sucesso
            </strong>
            <p className="text-sm font-medium text-black04 dark:text-gray-400">
              Parabéns! Sua proposta foi finalizada com sucesso. O link de
              formalização posso ser copiado abaixo, mas também será enviado via
              WhatsApp e SMS em alguns minutos, fique atento!.
            </p>
          </div>
          <div className="mt-6 flex justify-end gap-2">
            <Button
              variant="outline"
              className="w-[200px] rounded-full text-primary"
              onClick={copyLink}
              disabled={isLoading || isError || !data?.linkCliente}
            >
              Copiar link
            </Button>
          </div>
        </>
      )}

      <div className="mt-4 flex flex-col gap-2">
        <Button
          onClick={handleBackToInitial}
          className=" w-36 rounded-2xl font-semibold text-white "
        >
          Finalizar
        </Button>
      </div>
    </div>
  );
};
